// This exists so it can be mocked in tests
export default function readJson<T>(filePath: string): T {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  return require(filePath);
}
